const newsFeedId = state => state.newsFeedId;

export { newsFeedId };
